import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8","key":"svg-1"}]]

const IconSquareLetterB = createReactComponent('outline', 'square-letter-b', 'SquareLetterB', __iconNode);

export default IconSquareLetterB;